import React from 'react';
import { connect } from 'react-redux';

import { APOLLO_COMMUNITY } from 'ha/constants/pageNames';
import {
  withHermes,
  getLinkData,
  HermesProps,
  getInfo,
} from 'ha/modules/Hermes';
import { GlobalState } from 'ha/types/store';

import { HermesInfo, LinkData } from 'ha/modules/Hermes/types';
import { Page } from 'ha/modules/Page';
import { CommunityPageLayout } from '../components/CommunityPageLayout';
import { HermesData } from '../types';

const mapStateToProps = (state: GlobalState) => ({
  linkData: getLinkData(state),
  info: getInfo(state),
});

interface Props {
  linkData: LinkData[];
  info: HermesInfo;
}

const CommunityPageInternal: React.FC<
  Props & HermesProps<HermesData>
> = props => {
  const countryCode = props.data.country?.canonical;

  return (
    <Page
      name={APOLLO_COMMUNITY}
      category={APOLLO_COMMUNITY}
      hasFooter={false}
      hideIntercom
      traits={{ countryCode }}
    >
      <CommunityPageLayout {...props} />
    </Page>
  );
};

const CommunityPage = withHermes(
  connect(mapStateToProps)(CommunityPageInternal),
);
export { CommunityPage };
